import { AppDrawer } from "@/components/layout/elements/AppDrawer";
import { AppHeader } from "@/components/layout/elements/AppHeader";
import { SocketProvider } from "@/providers/SocketProvider";
import { useMeAutoRefresh } from "@/features/auth/hooks/useMeAutoRefresh";
import { withAuth } from "@/hoc/withAuth";
import { useVisible } from "@/hooks/useVisible";
import { FCC } from "@/types/common";
import { Box, Stack, styled } from "@mui/material";
import { Outlet } from "react-router-dom";

type TAdminLayoutProps = {
  enableHeader?: boolean;
  enableSidebar?: boolean;
};

export const AdminLayout: FCC<TAdminLayoutProps> = ({ children, enableHeader = true, enableSidebar = true }) => {
  const showDrawer = useVisible();
  useMeAutoRefresh();

  return (
    <SocketProvider>
      {enableHeader && <AppHeader isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />}
      <Stack width="100%" direction="row">
        {enableSidebar && <AppDrawer isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />}
        <ChildrenWrapper onClick={showDrawer.close}>
          <Stack position="relative" height="100%">
            <Outlet />
            {children}
          </Stack>
        </ChildrenWrapper>
      </Stack>
    </SocketProvider>
  );
};

export const AdminLayoutWithAuth = withAuth(AdminLayout);

const ChildrenWrapper = styled(Box)`
  padding: 24px;
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  margin: 0 auto;
`;
